import { Card, Tag, Descriptions, Empty } from "antd";
import trans, { isRTL } from "../../../../utils";
import { formatDateString } from "../../../../JsHelpers/DateFormat";
import { FaTrash } from "react-icons/fa6";
import { useDeleteCompanyProjectMutation } from "../../../../Redux/service/Companies/Company";
import { toast } from "react-toastify";
import { EditOutlined } from "@ant-design/icons";
import { useContext } from "react";
import { popupcontext } from "../../../../context/Popupscontext";
export function ProjectsTab({ data, manageProjects, refetch }) {
	const statusColors = {
		ACTIVE: `green`,
		INACTIVE: `red`,
	};

	const roleColors = {
		SUB_CONTRACTOR: `cyan`,
		CONTRACTOR: `orange`,
		QA: `purple`,
		CONSULTANT: `green`,
	};
	const { setIsAssigningProjects, setcurrentCompanyProjectId, setIsEditing } =
		useContext(popupcontext);
	const [deleteProject, { data: deletionData, isLoading }] =
		useDeleteCompanyProjectMutation();
	if (!data?.projects || data.projects.length === 0) {
		return <Empty description={trans("No projects assigned")} />;
	}
	const handleDeleteProject = async (companyId, projectId) => {
		const toastId = toast.loading(trans("Loading..."), {
			autoClose: false,
			rtl: isRTL,
		});

		try {
			const res = await deleteProject({ companyId, projectId }).unwrap();
			refetch();
			toast.update(toastId, {
				render: res?.message || trans("Project Unassigned successfully"),
				type: "success",
				isLoading: false,
				rtl: isRTL,
				autoClose: true,
			});
		} catch (err) {
			toast.update(toastId, {
				render:
					err?.data?.message || err?.error || trans("Something went wrong"),
				type: "error",
				isLoading: false,
				rtl: isRTL,
				autoClose: true,
			});
		}
	};

	return (
		<div style={{ padding: "16px 0" }}>
			<h3 style={{ marginBottom: 16 }}>{trans("Assigned Projects")}</h3>
			<div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
				{data.projects
					.filter((i) => i.status === "ACTIVE")
					.map((project, index) => (
						<Card
							key={project.companyProjectId || index}
							title={
								<div
									style={{
										display: "flex",
										alignItems: "center",
										gap: 8,
										justifyContent: "space-between",
									}}
								>
									<div>
										<span>{project.projectName || trans("Project")}</span>
										<Tag
											color={
												statusColors[project.status] || statusColors.INACTIVE
											}
											className="mx-2"
										>
											{trans(project.status)}
										</Tag>
										<Tag color={roleColors[project.role] || "default"}>
											{trans(project.role)}
										</Tag>
									</div>
									{manageProjects && (
										<div className="d-flex align-items-center">
											<EditOutlined
												title={trans("Edit Project")}
												size={14}
												cursor={true}
												className={`${isRTL ? "ms-3" : "me-3"}`}
												onClick={() => {
													setcurrentCompanyProjectId(project.companyProjectId);
													setIsAssigningProjects(true);
												}}
											/>
											<FaTrash
												title={trans("Unassign")}
												size={14}
												cursor={true}
												color="rgba(255, 0, 0, 0.726)"
												onClick={() =>
													handleDeleteProject(data.id, project.projectId)
												}
											/>
										</div>
									)}
								</div>
							}
							style={{ marginBottom: 16 }}
						>
							<Descriptions bordered column={2} size="small">
								<Descriptions.Item label={trans("Project Name")} span={2}>
									{project.projectName || "-"}
								</Descriptions.Item>
								<Descriptions.Item label={trans("City")} span={1}>
									{project.projectCity || "-"}
								</Descriptions.Item>
								<Descriptions.Item label={trans("State")} span={1}>
									{project.projectState || "-"}
								</Descriptions.Item>
								<Descriptions.Item label={trans("Contract Number")} span={1}>
									{project.contractNumber || "-"}
								</Descriptions.Item>
								<Descriptions.Item label={trans("Contract Value")} span={1}>
									{project.contractValue
										? `${Number(project.contractValue).toLocaleString()}`
										: "-"}
								</Descriptions.Item>
								<Descriptions.Item label={trans("Start Date")} span={1}>
									{project.startDate
										? formatDateString(project.startDate)
										: "-"}
								</Descriptions.Item>
								<Descriptions.Item label={trans("End Date")} span={1}>
									{project.endDate ? formatDateString(project.endDate) : "-"}
								</Descriptions.Item>
								<Descriptions.Item label={trans("SLA Response Time")} span={1}>
									{project.slaResponseTime
										? `${project.slaResponseTime} ${trans("hours")}`
										: "-"}
								</Descriptions.Item>
								<Descriptions.Item
									label={trans("SLA Completion Time")}
									span={1}
								>
									{project.slaCompletionTime
										? `${project.slaCompletionTime} ${trans("hours")}`
										: "-"}
								</Descriptions.Item>
								<Descriptions.Item label={trans("Assigned Zones")} span={2}>
									{project.assignedZones && project.assignedZones.length > 0
										? project.assignedZones.map((zone, idx) => (
												<Tag key={idx} style={{ marginRight: 4 }}>
													{zone?.name ? zone?.name : zone?.code}{" "}
													{zone?.code && zone?.name ? `- ${zone?.code}` : ""}
												</Tag>
											))
										: "-"}
								</Descriptions.Item>
								<Descriptions.Item label={trans("Team Count")} span={1}>
									{project.teamCount || 0}
								</Descriptions.Item>
								<Descriptions.Item label={trans("Total Members")} span={1}>
									{project.totalMembers || 0}
								</Descriptions.Item>
							</Descriptions>
						</Card>
					))}
			</div>
		</div>
	);
}
